// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__X-PX6","content":"styles_content__1vwJo","checkbox":"styles_checkbox__1PbOM","checkboxLabel":"styles_checkboxLabel__3TUf_"};